import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@p81-common/ui';

interface StyleProps {
  statusFailed?: boolean | undefined;
  backgroundColor?: string | undefined;
}

const createClasses = makeStyles<Theme, StyleProps>(theme => ({
  firstElementBGColor: (props: StyleProps) => {
    const { backgroundColor } = props;
    return {
      backgroundColor: backgroundColor,
      padding: theme.spacing(1.5),
      borderRadius: theme.spacing(0.5)
    };
  },

  gatewayBox: (props: StyleProps) => {
    const { statusFailed } = props;
    return {
      backgroundColor: statusFailed
        ? theme.palette.error[0]
        : theme.palette.success[200],
      borderRadius: theme.spacing(0.5),
      padding: theme.spacing(1.5),
      marginBottom: theme.spacing(2),
      '& .MuiBackdrop-root': {
        backgroundColor: 'transparent'
      }
    };
  },

  gatewayFailedButton: {
    backgroundColor: theme.palette.common.white,
    rotate: '90deg',
    borderRadius: '50%',
    width: theme.spacing(4),
    height: theme.spacing(4),
    position: 'absolute',
    right: theme.spacing(9.5),
    '&:hover': {
      backgroundColor: theme.palette.common.white
    }
  },

  gatewayFailedButtonIcon: {
    color: theme.palette.secondary[500]
  },

  innerContainer: {
    width: 420,
    color: theme.palette.primary[500],
    whiteSpace: 'normal',
    paddingBottom: theme.spacing(11.5)
  },
  title: {
    marginBottom: theme.spacing(1),
    fontSize: theme.spacing(2.75),
    fontWeight: theme.typography.fontWeightMedium
  },
  divider: {
    margin: theme.spacing(3, 0)
  },
  subTitle: {
    ...theme.typography.interactive1,
    color: theme.palette.primary[500],
    marginBottom: theme.spacing(0.5)
  },
  networkSubTitle: {
    ...theme.typography.interactive1,
    color: theme.palette.primary[500],
    marginBottom: theme.spacing(2)
  },
  midSubTitle: {
    ...theme.typography.interactive2,
    color: theme.palette.primary[400],
    marginBottom: theme.spacing(4)
  },
  indicator: {
    marginTop: theme.spacing(0.375),
    marginLeft: theme.spacing(1.25),
    textTransform: 'capitalize'
  },
  label: {
    ...theme.typography.interactive2,
    color: theme.palette.primary[400],
    marginBottom: theme.spacing(0.25)
  },
  value: {
    color: theme.palette.primary[500]
  },
  actionValue: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.primary[500]
  },
  capitalize: {
    textTransform: 'capitalize'
  },
  errorLabel: {
    ...theme.typography.interactive2,
    color: theme.palette.primary[400],
    marginBottom: theme.spacing(1)
  },
  networkId: {
    color: theme.palette.secondary[500]
  },
  linkColumn: {
    color: theme.palette.secondary[500]
  },
  menuItem: {
    display: 'flex'
  },
  menuIcon: {
    marginRight: theme.spacing(1)
  }
}));

export default createClasses;
